import { useGetUserTariffsQuery } from "@RTKQuery/user/tariffs/tariffs";
import style from "./BuyProxyPage.module.scss";
import { FreeProxy, Tariff } from "./components";
import { RiLoader5Fill } from "react-icons/ri";

export function BuyProxyPage() {
    const { data, isFetching } = useGetUserTariffsQuery()

    return (
        <main className={style.page}>
            <p className={style.pageName}>Купити проксі</p>
            <p className={style.descr}>Ми маємо декілька тарифів: обирайте найкращий під свої потреби.</p>
            <div className={style.tariffs}>
                {
                    isFetching
                    ? <>
                        <div className={style.sceleton}><RiLoader5Fill className={"animate-spin w-[60px] h-[60px]"} /></div>
                        <div className={style.sceleton}><RiLoader5Fill className={"animate-spin w-[60px] h-[60px]"} /></div>
                        <div className={style.sceleton}><RiLoader5Fill className={"animate-spin w-[60px] h-[60px]"} /></div>
                    </>
                    : data?.map(item => (
                        <Tariff key={item.id} tariffsDynamicData={item}/>
                    ))
                }
            </div>
            <FreeProxy />
        </main>
    )
}